// Finds hotel with cheapest visible top offer, and modifies topOfferData to

import {HotelType} from 'types/Hotel'
import {getCheapestTopOffer} from 'utils/offers'

import {isOfferEligibleForDealFreeze} from '@vio/shared/src/dealFreeze/utils/OfferEligibility'

// return only this offer - used to show the cheapest offer in BestDealModal
export const getHotelWithCheapestVisibleTopOffer = (
  results: HotelType[],
  isAuthenticated: boolean | null | undefined
): HotelType | null | undefined => {
  if (!results) return null
  let bestOffer: {
    bestPrice?: number
    hotel?: HotelType
  } = {
    bestPrice: undefined,
    hotel: undefined
  }

  for (const hotel of results) {
    if (!hotel?.topOfferData || !hotel?.offers) {
      continue
    }

    const topOfferIndexes = hotel?.topOfferData?.offerIndexes?.length
      ? hotel?.topOfferData.offerIndexes
      : [0, 1, 2]

    const bestOfferFromVisible = getCheapestTopOffer(
      topOfferIndexes,
      hotel?.offers,
      isAuthenticated
    )

    if (
      bestOffer.bestPrice &&
      bestOffer.bestPrice <= bestOfferFromVisible.price
    ) {
      continue
    }

    bestOffer = {
      bestPrice: bestOfferFromVisible.price,
      hotel: {
        ...hotel,
        topOfferData: {
          ...hotel.topOfferData,
          offerIndexes: [bestOfferFromVisible.topOfferIndex]
        }
      }
    }
  }

  return bestOffer.hotel
}

// Same shape as getHotelWithCheapestVisibleTopOffer but narrows visible offer
// indexes to deal-freeze-eligible offers first. Used by the SRP exit-popup DF
// variant to pick the offer it pitches.
export const getHotelWithCheapestVisibleFreezableOffer = (
  results: HotelType[],
  isAuthenticated: boolean | null | undefined
): HotelType | null | undefined => {
  if (!results) return null
  let bestOffer: {
    bestPrice?: number
    hotel?: HotelType
  } = {
    bestPrice: undefined,
    hotel: undefined
  }

  for (const hotel of results) {
    if (!hotel?.topOfferData || !hotel?.offers) {
      continue
    }

    const visibleIndexes = hotel?.topOfferData?.offerIndexes?.length
      ? hotel?.topOfferData.offerIndexes
      : [0, 1, 2]

    const freezableIndexes = visibleIndexes.filter(idx =>
      isOfferEligibleForDealFreeze(hotel.offers?.[idx]?.tags)
    )

    if (!freezableIndexes.length) continue

    const bestOfferFromVisible = getCheapestTopOffer(
      freezableIndexes,
      hotel?.offers,
      isAuthenticated
    )

    if (bestOfferFromVisible.topOfferIndex === undefined) continue

    if (
      bestOffer.bestPrice &&
      bestOffer.bestPrice <= bestOfferFromVisible.price
    ) {
      continue
    }

    bestOffer = {
      bestPrice: bestOfferFromVisible.price,
      hotel: {
        ...hotel,
        topOfferData: {
          ...hotel.topOfferData,
          offerIndexes: [bestOfferFromVisible.topOfferIndex]
        }
      }
    }
  }

  return bestOffer.hotel
}
